export function Divider(props: { class?: string }) {
  return <div class={`w-full !h-6px rounded-lg ${props.class ?? ""}`} />;
}
